import {useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';
import {REFERRAL_KEY,readReferral,rememberReferral} from '@/lib/referrals';
export default function ReferralAcknowledgment(){
 const location=useLocation(),[referral,setReferral]=useState(null),[message,setMessage]=useState('');
 useEffect(()=>{let live=true;setMessage('');setReferral(null);
  const incoming=new URLSearchParams(location.search).get('ref');const saved=readReferral();const code=incoming||saved?.code;
  if(!code)return;
  if(incoming)try{localStorage.removeItem(REFERRAL_KEY);}catch{}
  fetch('/api/referrals/resolve?code='+encodeURIComponent(code),{cache:'no-store'}).then(async r=>{if(!r.ok){const error=Error(r.status===404?'This referral link is no longer available.':'Unable to confirm this referral right now.');error.status=r.status;throw error;}return r.json();}).then(data=>{
   if(!live)return;
   if(location.pathname!==data.event_path)return;
   const record=rememberReferral(data);setReferral(record);
   window.dispatchEvent(new CustomEvent('fotg-referral-updated',{detail:record}));
  }).catch(e=>{if(!live)return;if(e.status===400||e.status===404)try{localStorage.removeItem(REFERRAL_KEY);}catch{}if(incoming)setMessage(e.message);});return()=>{live=false};
 },[location.pathname,location.search]);
 if(!referral&&!message)return null;
 return <aside role="status" style={{background:'#172019',color:'#f5f0e8',padding:'12px 24px',textAlign:'center',borderBottom:'1px solid #426348',fontSize:14}}>
  {referral?<>You’re supporting <strong>{referral.display_name}</strong> with this referral. Your ticket price stays the same.</>:message}
 </aside>;
}
